import React, { SyntheticEvent } from 'react';
import { CouponPriceRangeInput } from '@api/graphql/types';
import { compose } from 'react-apollo';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import FormRow from '@components/Form/FormRow';
import DeleteButton from '@components/DeleteButton';
import Input from '@components/Form/Input';

interface Props {
    name: string;
    value: CouponPriceRangeInput[];
    onChange: ( value: CouponPriceRangeInput[], name: string) => void;
}

class PriceRangesField extends React.Component<Props & InjectedIntlProps> {

    private add = (e: SyntheticEvent) => {
        e.preventDefault();
        const value = [...this.props.value, {from: 0, discount: 0}];
        this.props.onChange(value, this.props.name);
    }

    private renderAdd = () => {
        return (
            <button className="btn btn-primary btn-block" onClick={this.add}>{this.props.intl.formatMessage({id: 'common.add'})}</button>
        );
    }

    private remove = (index: number) => {
        const value = [...this.props.value];
        value.splice(index, 1);
        this.props.onChange(value, this.props.name);
    }

    private onChange = (index: number) => (val: number, name: string) => {
        const value = [...this.props.value];
        value[index][name] = val;
        this.props.onChange(value, this.props.name);
    }

    private renderValue = () => {
        if (!this.props.value) {
            return null;
        }
        return this.props.value.map((item, index) => {
            return (
                <div className="row" key={index}>
                    <div className="col-sm-2">
                        <label className="form-label">Összeghatár</label>
                    </div>
                    <div className="col-sm-3">
                        <Input type="number" name="from" value={item.from} onChange={this.onChange(index)} />
                    </div>
                    <div className="col-sm-2">
                        <label className="form-label">Kedvezmény</label>
                    </div>
                    <div className="col-sm-3">
                        <Input type="number" name="discount" value={item.discount} onChange={this.onChange(index)} />
                    </div>
                    <div className="col-sm-2">
                        <DeleteButton className="btn-block" onClick={this.remove} value={index} />
                    </div>
                </div>
            );
        });
    }

    public render() {
        return (
            <>
                {this.renderValue()}
                <FormRow>
                    {this.renderAdd()}
                </FormRow>
            </>
        );
    }
}

export default compose(
    injectIntl,
)(PriceRangesField);



// WEBPACK FOOTER //
// ./src/modules/Coupon/components/PriceRangesField.tsx